module.exports = __webpack_public_path__ + "sb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sb.svg
// module id = 1045
// module chunks = 0